import AppBannerCSS from 'app/common/react/components/growth/unauth/AppBanner/AppBannerCSS';
import EuCookieBarCSS from 'app/common/react/components/growth/unauth/header/EuCookieBar/EuCookieBarCSS';
import TabletAppInterstitialCSS from 'app/common/react/components/growth/unauth/header/TabletAppInterstitial/TabletAppInterstitialCSS';
import UnauthHeaderCSS from 'app/common/react/components/growth/unauth/header/UnauthHeader/UnauthHeaderCSS';

const cssStyles = (isTablet, isOpen, pinImageWidthMax) => {
  if (isTablet) {
    return TabletAppInterstitialCSS() + EuCookieBarCSS() + UnauthHeaderCSS() + AppBannerCSS();
  } else {
    return UnauthHeaderCSS(isOpen, pinImageWidthMax) + EuCookieBarCSS();
  }
};

export default cssStyles;
